<template>
  <Search />
</template>

<script>
import Search from '@/components/Search';
export default {
  components: {
    Search
  },
  nuxtI18n: {
    paths: {
      en: '/merch/vectors/p/:page'
    }
  }
};
</script>

<style></style>
